import React from "react";
import Zoom from 'react-reveal/Zoom';
import styled, { keyframes, css } from "styled-components";

function Brand_slider2() {
  const row1 = [
    {
      src: "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/7ae42bac3b34999c0db3.png",
      alt: "Two_Sigma"
    },
    {
      src: "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/b2bd91d7b87b2181ca45.png",
      alt: "Microsoft"
    },
    {
      src: "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/6591cdc0702b32310306.png",
      alt: "Amazon"
    },
    {
      src: "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/3b7d9f4b073deb6a9b74.png",
      alt: "Bloomberg"
    },
    {
      src: "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/3cd767dea94a85078ca4.png",
      alt: "Facebook"
    },
    {
      src: "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/a2b3c3709ffedce2a22a.png",
      alt: "Google"
    },
    {
      src: "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/0384060dcbf73b6a707c.png",
      alt: "Simon"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/infosys-3.svg",
      alt: "infosys"
    },
    
    {
      src: "https://cdn.worldvectorlogo.com/logos/wipro-1.svg",
      alt: "wipro"
    },
    {
      src: "https://images.seeklogo.com/logo-png/30/2/tech-mahindra-logo-png_seeklogo-304147.png",
      alt: "Tech Mahindra"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/capgemini-201x-logo.svg",
      alt: "Capgemini"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/oracle-6.svg",
      alt: "Oracle"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/zoho-1.svg",
      alt: "zoho"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/ey.svg",
      alt: "EY"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/flipkart.svg",
      alt: "Flipkart"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/paytm-1.svg",
      alt: "Paytm"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/deloitte-1.svg",
      alt: "Deloitte"
    },
    {
      src: "https://images.seeklogo.com/logo-png/43/2/blinkit-logo-png_seeklogo-438944.png",
      alt: "Blinkit"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/samsung-8.svg",
      alt: "Samsung"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/salesforce-2.svg",
      alt: "Salesforce"
    }
  ];

  const row2 = [
    {
      src: "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/35e044b3354aaa0caed5.png",
      alt: "Morgan_Stanley"
    },
    {
      src: "https://www.iima.ac.in/themes/iima/images/logo.svg",
      alt: "IIMA"
    },
    {
      src: "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/f50ae7cbf6cc805bdadc.png",
      alt: "NBC_Universal"
    },
    {
      src: "https://www.iitb.ac.in/themes/custom/iitb_bootstrap/logo.png",
      alt: "IIT Bombay"
    },
    {
      src: "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/6c585c33ca6c71c79bb7.png",
      alt: "Black_Rock"
    },
    {
      src: "https://www.iitkgp.ac.in//assets/pages/images/logo.png",
      alt: "IIT Kharagpur"
    },
    {
      src: "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/9dd55e54b5a28658bf4e.png",
      alt: "Consensys"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/tata-consultancy-services-1.svg",
      alt: "TCS"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/hcltech-1.svg",
      alt: "hcltech"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/cognizant-1.svg",
      alt: "Conizant"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/ibm.svg",
      alt: "IBM"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/swiggy-logo.svg",
      alt: "Swiggy"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/accenture-6.svg",
      alt: "Accenture"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/google-pay-2.svg",
      alt: "Gpay"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/zomato-1.svg",
      alt: "Zomato"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/spotify-logo.svg",
      alt: "Spotify"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/uber-2.svg",
      alt: "Uber"
    },
    {
      src: "https://cdn.worldvectorlogo.com/logos/meta-3.svg",
      alt: "Meta"
    }
  ];


  return (
    <>
    <Zoom className="">
    <AppContainer>
      <Wrapper>
        <Marquee>
          <MarqueeGroup>
            {row1.map((el) => (
              <ImageGroup key={el.src}>
                <Image src={el.src} alt={el.alt} />
              </ImageGroup>
            ))}
          </MarqueeGroup>
          <MarqueeGroup>
            {row1.map((el) => (
              <ImageGroup key={el.src}>
                <Image src={el.src} alt={el.alt} />
              </ImageGroup>
            ))}
          </MarqueeGroup>
        </Marquee>
        <Marquee>
          <MarqueeGroup2>
            {row2.map((el) => (
              <ImageGroup key={el.src}>
                <Image src={el.src} alt={el.alt} />
              </ImageGroup>
            ))}
          </MarqueeGroup2>
          <MarqueeGroup2>
            {row2.map((el) => (
              <ImageGroup key={el.src}>
                <Image src={el.src} alt={el.alt} />
              </ImageGroup>
            ))}
          </MarqueeGroup2>
        </Marquee>
      </Wrapper>
    </AppContainer>
    </Zoom>
    </>
  );
}

export default Brand_slider2;

const AppContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const Marquee = styled.div`
  display: flex;
  width: 100%; 
  overflow: hidden;
  user-select: none;

  mask-image: linear-gradient(
    to right,
    hsl(0 0% 0% / 0),
    hsl(0 0% 0% / 1) 10%,
    hsl(0 0% 0% / 1) 90%,
    hsl(0 0% 0% / 0)
  );
`;

const scrollX = keyframes`
  from {
    left: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`;

// const common = css`
//   flex-shrink: 0;
//   display: flex;
//   align-items: center;
//   justify-content: space-around;
//   white-space: nowrap;
//   width: 100%;
//   animation: ${scrollX} 30s linear infinite;
// `;
const common = css`
  display: flex;
  align-items: center;
  gap: 20px;             
  flex-shrink: 0;        
  white-space: nowrap;
  animation: ${scrollX} 50s linear infinite;
`;

const MarqueeGroup = styled.div`
  ${common}
  
`;
const MarqueeGroup2 = styled.div`
  ${common}
  animation-direction: reverse;
  animation-delay: -3s;
`;


// const ImageGroup = styled.div`
//   display: grid;
//   place-items: center;
//   width: clamp(10rem, 1rem + 40vmin, 30rem);
//   padding: calc(clamp(10rem, 1rem + 30vmin, 30rem) / 10);
// `;

// const Image = styled.img`
//   object-fit: contain;
//   width: 100%;
//   height: 100%;
//   /* border: 1px solid black; */
//   border-radius: 0.5rem;
//   aspect-ratio: 16/9;
//   padding: 5px 20px;
//   box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
// `;

const ImageGroup = styled.div`
  display: grid;
  place-items: center; 
  width: 170px;    
  height: 110px;   
  padding: calc(clamp(10rem, 1rem + 30vmin, 30rem) / 10);  
  flex-shrink: 0;  
`;

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
  /* border: 1px solid black; */
  border-radius: 0.5rem;
  aspect-ratio: 16/9;
  padding: 5px 20px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;


